class ModalGallery extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.id;
    this.modalWrapper = this.querySelector(`#${this.sectionId}`);

    this.setupClickListeners();
    this.checkHashForModal();
  }

  setupClickListeners() {
    this.addEventListener('click', (ev) => {
      const clickedElement = ev.target.closest('button');

      if (!clickedElement) return;

      switch (clickedElement.dataset.buttonType) {
        case 'modal-close':
          this.hideModal();
          break;
        case 'modal-trigger':
          this.showModal(clickedElement.dataset.modalTrigger);

          trapFocus(this.modalWrapper);
          break;
        case 'modal-navigation':
          this.showModal(clickedElement.dataset.gotoId);
          break;
        case 'share-buttons':
          releaseFocus(this.modalWrapper);
          clickedElement.nextElementSibling.classList.toggle('hidden');

          for (const child of clickedElement.nextElementSibling.children) {
            child.classList.toggle('hidden');
          }
          trapFocus(this.modalWrapper);
          clickedElement.focus();
          break;
      }
    });

    this.modalWrapper.addEventListener('custom:escape', (ev) => {
      this.hideModal();
    });
  }

  checkHashForModal() {
    if (window.location.hash) {
      const hash = window.location.hash.replace('#', '');
      if (this.querySelector(`[data-modal-content-container="${hash}"]`)) {
        this.showModal(`${window.location.hash.replace('#', '')}`);
      }
    }
  }

  changeUrl(activeState) {
    if (activeState) {
      window.history.replaceState('', '', `#${this.currentModalId}`);
    } else {
      var uri = window.location.toString();
      if (uri.indexOf('#') > 0) {
        var cleanUri = uri.substring(0, uri.indexOf('#'));
        window.history.replaceState({}, document.title, cleanUri);
      }
    }
  }

  showModal(modalContentId) {
    const elementsToRender = [
      {
        id: `${this.sectionId}-image`,
        replacingSelector: `#${modalContentId}-image`,
      },
      {
        id: `${this.sectionId}-text`,
        replacingSelector: `#${modalContentId}-text`,
      },
    ];

    const modalContentContainer = this.querySelector(`[data-modal-content-container="${modalContentId}"]`);

    elementsToRender.forEach((element) => {
      const elementToReplace = document.getElementById(element.id);
      if (elementToReplace)
        elementToReplace.innerHTML = modalContentContainer.querySelector(element.replacingSelector).outerHTML;
    });

    this.modalWrapper.setAttribute('aria-hidden', 'false');
    this.modalWrapper.classList.remove('hidden');
    this.currentModalId = modalContentId;
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('max-h-100vh');
    this.addEventListener('keydown', this.handleKeyDown, false);

    this.modalWrapper
      .querySelector('[data-modal-previous]')
      .setAttribute('data-goto-id', modalContentContainer.dataset.previousId);
    this.modalWrapper
      .querySelector('[data-modal-next]')
      .setAttribute('data-goto-id', modalContentContainer.dataset.nextId);

    this.changeUrl(true);
  }

  hideModal() {
    this.modalWrapper.setAttribute('aria-hidden', 'true');
    this.modalWrapper.classList.add('hidden');
    this.querySelector(`[data-modal-trigger="${this.currentModalId}"]`).focus();
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('max-h-100vh');
    this.removeEventListener('keydown', this.handleKeyDown, false);

    this.changeUrl(false);
  }

  handleKeyDown(event) {
    if (event.key === 'ArrowLeft') {
      this.modalWrapper.querySelector('[data-modal-previous]').click();
    } else if (event.key === 'ArrowRight') {
      this.modalWrapper.querySelector('[data-modal-next]').click();
    }
  }
}

customElements.define('modal-gallery', ModalGallery);
